import { Card, Empty, Tag, Typography } from "antd";

const { Paragraph } = Typography;

/** R1 では画面の枠だけ置く。中身は各段階で実装する。 */
export function Placeholder({
  title,
  phase,
  appName,
}: {
  title: string;
  phase: string;
  appName: string;
}) {
  return (
    <Card title={title} extra={<Tag color="blue">{phase} で実装</Tag>}>
      <Empty
        description={
          <>
            <Paragraph style={{ marginBottom: 4 }}>
              {appName}の「{title}」はまだ実装していない。
            </Paragraph>
            <Paragraph type="secondary" style={{ marginBottom: 0 }}>
              土台(ログイン・ポータル・監査・設定)は R1 で動いている。この画面は {phase}{" "}
              で作る。
            </Paragraph>
          </>
        }
      />
    </Card>
  );
}
